import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const PanelStatusChanged = createAction(
  '[Data Customization: Brand Management]: Panel Status Changed'
);

export const CouponSetChanged = createAction(
  '[Data Customization: Brand Management]: Coupon Set Changed',
  props<{ selectedCouponSetCode: string }>()
);

export const BrandCodeChanged = createAction(
  '[Data Customization: Brand Management]: Brand Code Changed',
  props<{ brandCode: string }>()
);

export const GetCoupons = createAction(
  '[Data Customization: Brand Management]: Get Coupons'
);

export const GetCouponsSuccess = createAction(
  '[Data Customization: Brand Management]: Get Coupons Success',
  props<{ res: any }>()
);

export const GetCouponsFailed = createAction(
  '[Data Customization: Brand Management]: Get Coupons Failed',
  props<{ error: HttpErrorResponse }>()
);

export const ClearBrandOptions = createAction(
  '[Data Customization: Brand Management]: Clear Brand Options'
);
